<template>
<div id="about" class="container">

        <div class="middlediv" id="afewwords" style="margin-top: 3%;" >
        
                <div style="margin-top: 3%;">
                        <img src="../assets/1.jpg" id="profilepic" class="img-fluid rounded-circle idpic" alt="picture representing Himanshu Khudania, SoftwareTester, webdeveloper">
                </div>
            
            <h4 class="centeredmessage" style="margin-top: 3%;">Few Words About Me</h4>
        <p>
            I speak Hindi, English, a bit of Bengali, Marwadi and also Bhojpuri... and I do Software Testing using Selenium2.0 with Java, I also have knowledge of Performance Testing using Jmeter, Bug reporting tool like Bugzilla <br>
            I code in HTML, CSS and JavaScript, Nodejs, Vuejs. For Responsive design I normally  use either MaterializeCSS or Bootstrap. I am a front-end developer for the time being, aim to become a full stack developer.
        </p>
       <p> I am also a part of wonderful community, around #100DaysofCode, where we learn and practice code everyday and together to imporove our coding skills. It is an awesome way to learn, grow and adapt to new technologies </p>
        <p>
            When, I'm not Coding or Working, I play football, play Videogames or watch movies. I also love to read Novels in my free time.
        </p>
    </div>

    <div id="cv" class="middlediv">
        <h4 class="centeredmessage">
             Resume       
        </h4>
        <p class="centeredmessage">
            <a href="https://himanshu-khudania.github.io/resume/" target="_blank" class="btn btn-lg btn-outline btn-danger">
                        <i class="fa fa-arrow-right "></i> Redirect to Resume
                    </a>                
        </p>             
    </div>
    </div>

</template>

<script>
export default {
   name: 'about',
    data (){
        return {
            
        }
    }
}
</script>



<style scoped>
.centeredmessage {
  text-align: center;
  margin-bottom: 3%;
}

.idpic {
  width: 150px;
  display: block;
  margin: auto;
  
}

.middlediv {
  margin-top: 60px;
}


p{
    font-family:  cursive;
}

</style>



// WEBPACK FOOTER //
// src/components/About.vue